import React, { useEffect, useState } from 'react'
import MasterLayout from '../masterLayout/MasterLayout'
import Breadcrumb from './Breadcrumb'
import { Icon } from '@iconify/react/dist/iconify.js'

import JobsTable from './JobTable'
import { Link } from 'react-router-dom'
import CompanyJobTable from './CompanyJobTable'
import { Card, CardBody, Spinner } from 'react-bootstrap'
import { API_URL } from '..'

export default function JobsPage() {
  const [jobsData , setJobData] = useState([])
  const [active , setActive] = useState(null)
  const [loadingTrue , setloadingTrue] = useState(false)
  const [currentUser , setCurrentUser] = useState({})
  const [currentValues, setValues] = useState({
    new:0,
    accept: 0,
    total: 0,
    declined: 0,
    completed: 0,
    schedule: 0,
    quotes:0,
  });

  const fetchJobs = async ()=>{
    setloadingTrue(true)
    const user = JSON.parse(localStorage.getItem('user'));
    setCurrentUser(user)
    
    let headersList = {
        "Accept": "*/*",
        "Content-Type": "application/json"
       }
       let url= "";
       let jsonBody= JSON.stringify({
        "id": user.id
       });
       if(user.role == 'user'){
          let response = await fetch(`${API_URL}/api/jobs-by-user/${user.id}`, { 
            method: "POST",
            body:jsonBody,
            headers: headersList
          });
          let data = await response.json();
          setJobData(data.reverse())
          const acceptCount = data.filter(
            (item) =>  item.status === "in-progress"
          ).length;
      
          const declinedCount = data.filter(
            (item) => item.status === "declined"
          ).length;
          const newCount = data.filter(
            (item) => item.status === "new" && item.status_for_job === 'New Call'
          ).length;
          const scheduleCount = data.filter(
            (item) => item.status_for_job === 'Schedule'
          ).length;
          const quoteCount = data.filter(
            (item) => item.status_for_job === 'Quote'
          ).length;
      
          const completedCount = data.filter(
            (item) => item.status === "completed"
          ).length;
      
          const totalCount = data.length;
          setValues({
            accept: acceptCount,
            declined: declinedCount,
            completed: completedCount,
            total: totalCount,
            new:newCount,
            schedule: scheduleCount,
            quotes: quoteCount

          });
       }else{
        let response = await fetch( `${API_URL}/api/jobs`, { 
          method: "GET",
          headers: headersList
        });
        
        let data = await response.json();
        setloadingTrue(false)
        if(response.status === 200){
            setJobData(data)
            console.log(data)
           if(data.length !==0){
               const acceptCount = data.filter(
                   (item) => item.status === "in-progress"
                 ).length;
             
                 const declinedCount = data.filter(
                   (item) => item.status === "declined"
                 ).length;
             
                 const completedCount = data.filter(
                   (item) => item.status === "completed"
                 ).length;
                 const newCount = data.filter(
                    (item) => item.status === "new" && item.status_for_job === 'New Call'
                  ).length;
                  const scheduleCount = data.filter(
                    (item) => item.status_for_job === 'Schedule'
                  ).length;
                  const quoteCount = data.filter(
                    (item) => item.status_for_job === 'Quote'
                  ).length;
                
                 const totalCount = data.length;
                 setValues({
                   accept: acceptCount,
                   declined: declinedCount,
                   completed: completedCount,
                   total: totalCount,
                   new: newCount,
                   schedule: scheduleCount,
                   quotes: quoteCount
                 });
           }

        }
       }
       
      
  }
  const fetchJobsCompany = async ()=>{
    setloadingTrue(true)
    const user = JSON.parse(localStorage.getItem('user'));
    setCurrentUser(user)
    let headersList = {
      "Accept": "*/*",
      "Content-Type": "application/json"
    }
       if(user.role === 'admin'){
        let response = await fetch( `${API_URL}/api/jobs`, { 
          method: "GET",
          headers: headersList
        });
        let data = await response.json();
        setloadingTrue(false)
        if(response.status === 200){
            setJobData(data)
           if(data.length !==0){
               const acceptCount = data.filter(
                   (item) => item.status === "in-progress"
                 ).length;
             
                 const declinedCount = data.filter(
                   (item) => item.status === "declined"
                 ).length;
             
                 const completedCount = data.filter(
                   (item) => item.status === "completed"
                 ).length;
                 const newCount = data.filter(
                    (item) => item.status === "new" && item.status_for_job === 'New Call'
                  ).length;
                  const scheduleCount = data.filter(
                    (item) => item.status_for_job === 'Schedule'
                  ).length;
                  const quoteCount = data.filter(
                    (item) => item.status_for_job === 'Quote'
                  ).length;
                
                 const totalCount = data.length;
                 setValues({
                   accept: acceptCount,
                   declined: declinedCount,
                   completed: completedCount,
                   total: totalCount,
                   new: newCount,
                   schedule: scheduleCount,
                   quotes: quoteCount
                 });
           }
          }
       }else{
      
        let response = await fetch(`${API_URL}/api/job/affiliate/fetch/${user.id}`, { 
            method: "GET",
            headers: headersList
          });
          
          let data = await response.json();
        //   console.log(data)
        if(response.status === 200){
          setloadingTrue(false)
            setJobData(data.data.reverse())
            if(data.data.length !==0){
                const acceptCount = data.data.filter(
                    (item) => item.status === "in-progress"
                  ).length;
              
                  const declinedCount = data.data.filter(
                    (item) => item.status === "declined"
                  ).length;
              
                  const completedCount = data.data.filter(
                    (item) => item.status === "completed"
                  ).length;
                  const newCount = data.data.filter(
                    (item) => item.status === "new" && item.status_for_job === "New Call"
                  ).length;
                  const scheduleCount = data.data.filter(
                    (item) => item.status_for_job === "Schedule"
                  ).length;
                  const quoteCount = data.data.filter(
                    (item) => item.status_for_job === "Quote"
                  ).length;
              
                  const totalCount = data.data.length;
                  setValues({
                    accept: acceptCount,
                    declined: declinedCount,
                    completed: completedCount,
                    total: totalCount,
                    new: newCount,
                    schedule: scheduleCount,
                    quotes: quoteCount
                  });
              }
        }else{
          setloadingTrue(false)
        }
      }
       
       
      
  }
useEffect(()=>{
  const user = JSON.parse(localStorage.getItem('user'));
  if(user?.role == 'admin' || user?.role ==='user'){
    fetchJobs()
  }else{
    fetchJobsCompany()
  }
},[1])
  return (
    <>
     <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Jobs" />
          
          
        {/* TableDataLayer */}
          { loadingTrue == false  ?
        <div className="row" style={{columnGap:10}}>
                <div className="col-md-2 card p-3 shadow-2 radius-8 border input-form-light h-100 bg-gradient-end-1">
                 <Link to={'/leads/total'}>
                    <div className="">
                        <div className="card-body p-0">
                            <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                                <div className="d-flex align-items-center gap-2">
                                    <span className="mb-0 w-48-px h-48-px bg-primary-600 flex-shrink-0 text-white d-flex justify-content-center align-items-center rounded-circle h6 mb-0">
                                        <Icon
                                             icon="iconamoon:discount-fill"
                                             className="icon"
                                        />
                                    </span>
                                    <div>
                                        <span className="mb-2 fw-medium text-secondary-light text-sm">
                                            Total
                                        </span>
                                        <h6 className="fw-semibold">{currentValues.total}</h6>
                                    </div>
                                </div>
                             

                            </div>
                            
                        </div>
                    </div>
                 </Link>
                </div>
                <div className="col-md-2 card p-3 shadow-2 radius-8 border input-form-light h-100 bg-gradient-end-1">
                 <Link to={'/leads/new'}>
                    <div className="">
                        <div className="card-body p-0">
                            <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                                <div className="d-flex align-items-center gap-2">
                                    <span className="mb-0 w-48-px h-48-px bg-info-600 flex-shrink-0 text-white d-flex justify-content-center align-items-center rounded-circle h6 mb-0">
                                        <Icon
                                            icon="iconamoon:discount-fill"
                                            className="icon"
                                        />
                                    </span>
                                    <div>
                                        <span className="mb-2 fw-medium text-secondary-light text-sm">
                                            In-Queue
                                        </span>
                                        <h6 className="fw-semibold">{currentValues.new}</h6>
                                    </div>
                                </div>
                             

                            </div>
                            
                        </div>
                    </div>
                 </Link>
                </div>
                <div className="col-md-2 card p-3 shadow-2 radius-8 border input-form-light h-100 bg-gradient-end-1">
                   <Link to={'/leads/in-progress'}>
                    <div className="">
                        <div className="card-body p-0">
                            <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                                <div className="d-flex align-items-center gap-2">
                                    <span className="mb-0 w-48-px h-48-px bg-primary flex-shrink-0 text-white d-flex justify-content-center align-items-center rounded-circle h6">
                                        <Icon
                                             icon="iconamoon:discount-fill"
                                             className="icon"
                                        />
                                    </span>
                                    <div>
                                        <span className="mb-2 fw-medium text-secondary-light text-sm">
                                            Active 
                                        </span>
                                        <h6 className="fw-semibold">{currentValues.accept}</h6>
                                    </div>
                                </div>
                               
                            </div>
                          
                        </div>
                    </div>
                    </Link>
                </div>
                <div className="col-md-2 card p-3 shadow-2 radius-8 border input-form-light h-100 bg-gradient-end-1">
                    <Link to={'/leads/declined'}>
                    <div className="">
                        <div className="card-body p-0">
                            <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                                <div className="d-flex align-items-center gap-2">
                                    <span className="mb-0 w-48-px h-48-px bg-primary text-white flex-shrink-0 d-flex justify-content-center align-items-center rounded-circle h6">
                                        <Icon
                                            icon="iconamoon:discount-fill"
                                            className="icon"
                                        />
                                    </span>
                                    <div>
                                        <span className="mb-2 fw-medium text-secondary-light text-sm">
                                            Declined
                                        </span>
                                        <h6 className="fw-semibold">{currentValues.declined}</h6>
                                    </div>
                                </div>
                             
                            </div>
                          
                        </div>
                    </div></Link>
                </div>
                <div className="col-md-2 card p-3 shadow-2 radius-8 border input-form-light h-100 bg-gradient-end-1">
                    <Link to={'/leads/completed'}>
                    <div className="">
                        <div className="card-body p-0">
                            <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                                <div className="d-flex align-items-center gap-2">
                                    <span className="mb-0 w-48-px h-48-px bg-primary text-white flex-shrink-0 d-flex justify-content-center align-items-center rounded-circle h6">
                                        <Icon
                                            icon="iconamoon:discount-fill"
                                            className="icon"
                                        />
                                    </span>
                                    <div>
                                        <span className="mb-2 fw-medium text-secondary-light text-sm">
                                            Completed 
                                        </span>
                                        <h6 className="fw-semibold">{currentValues.completed}</h6>
                                    </div>
                                </div>
                             
                             
                            </div>
                          
                        </div>
                    </div></Link>
                </div>
                <div className="col-md-2 card p-3 shadow-2 radius-8 border input-form-light h-100 bg-gradient-end-1 mt-3">
                    <Link to={'/leads/schedule'}>
                    <div className="">
                        <div className="card-body p-0">
                            <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                                <div className="d-flex align-items-center gap-2">
                                    <span className="mb-0 w-48-px h-48-px bg-primary text-white flex-shrink-0 d-flex justify-content-center align-items-center rounded-circle h6">
                                        <Icon
                                            icon="iconamoon:discount-fill"
                                            className="icon"
                                        />
                                    </span>
                                    <div>
                                        <span className="mb-2 fw-medium text-secondary-light text-sm">
                                            Scheduled
                                        </span>
                                        <h6 className="fw-semibold">{currentValues.schedule || 0}</h6>
                                    </div>
                                </div>
                             
                             
                            </div>
                          
                        </div>
                    </div></Link>
                </div>
                <div className="col-md-2 card p-3 shadow-2 radius-8 border input-form-light h-100 bg-gradient-end-1 mt-3">
                    <Link to={'/leads/quotes'}>
                    <div className="">
                        <div className="card-body p-0">
                            <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                                <div className="d-flex align-items-center gap-2">
                                    <span className="mb-0 w-48-px h-48-px bg-primary text-white flex-shrink-0 d-flex justify-content-center align-items-center rounded-circle h6">
                                        <Icon
                                            icon="iconamoon:discount-fill"
                                            className="icon"
                                        />
                                    </span>
                                    <div>
                                        <span className="mb-2 fw-medium text-secondary-light text-sm">
                                            Quotes
                                        </span>
                                        <h6 className="fw-semibold">{currentValues.quotes || 0}</h6>
                                    </div>
                                </div>
                             
                             
                            </div>
                          
                        </div>
                    </div></Link>
                </div>
             
            </div>:null
            }
            <br></br>
          
            
        {
         currentUser?.role === 'admin' && jobsData.length !==0  && loadingTrue ==false ?  <JobsTable jobsData={jobsData.reverse()}/> : null

        }
        {
           currentUser?.role === 'owner'  && jobsData.length !==0  && loadingTrue ==false ?      <CompanyJobTable jobsData={jobsData.reverse()}/>: null 
        }
        {
            jobsData.length === 0 && loadingTrue ===false? 
            <Card className="mt-20">
                <CardBody>
                    <p className="text-center">No Job Listed Yet <Link to={'/add-lead'} className="text-primary" style={{textDecoration:'underline'}}>Create New</Link></p>
                </CardBody>
            </Card> :null
        }
 
        </MasterLayout>
    </>
  )
}
